import DatabaseView from "../../relays/cache/database";

export default function TaskManagerDatabase() {
  return <DatabaseView />;
}
